import React from 'react';

// Click-to-call through Hopscotch Phones.
// Set REACT_APP_PHONE_URL (e.g. https://hopscotch-phone-....herokuapp.com) on the Heroku app
// before building. Even then, links and the Calls section only show in a browser that has
// opened Mission Control once with ?hsphone=on (turn off with ?hsphone=off), so it can be
// tested on live Mission Control without dispatchers seeing any change.
const PHONE_URL = (process.env.REACT_APP_PHONE_URL || '').replace(/\/+$/, '');

export function phoneEnabled() {
    if (!PHONE_URL) return false;
    try {
        const p = new URLSearchParams(window.location.search).get('hsphone');
        if (p === 'on') window.localStorage.setItem('hsphone', '1');
        if (p === 'off') window.localStorage.removeItem('hsphone');
        return window.localStorage.getItem('hsphone') === '1';
    } catch (e) {
        return false;
    }
}

const CallLink = ({ number, orderId, label = 'Customer', name, children }) => {
    if (!number || !phoneEnabled()) return <>{children}</>;
    const q = new URLSearchParams({ to: number, label });
    if (orderId) q.set('order', orderId);
    if (name) q.set('name', name);
    return (
        <a href={`${PHONE_URL}/dial?${q.toString()}`} target="hsphone-dial" title="Call with Hopscotch Phones">
            {children}
        </a>
    );
};

export default CallLink;
